let _ = window._;
let Backbone = window.Backbone;
let $ = jQuery;

export default Backbone.View.extend({
  tagName: 'div',
  template: _.template($('#userContent-item-tpl').html()),
  className: 'userContent__item',
  events: {

  },

  initialize: function() {
    this.render()
  },

  render: function() {
    this.$el.html(this.template(this.model.toJSON()));
    return this;
  }
});


// WEBPACK FOOTER //
// ./assets/src/javascripts/userContent/grid/Item.view.js